import { render, staticRenderFns } from "./addManager.vue?vue&type=template&id=0f18bc52&scoped=true&"
import script from "./addManager.vue?vue&type=script&lang=js&"
export * from "./addManager.vue?vue&type=script&lang=js&"
import style0 from "./addManager.vue?vue&type=style&index=0&id=0f18bc52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f18bc52",
  null
  
)

export default component.exports